module.exports = __webpack_public_path__ + "static/sti-72202deb41834450b2fc4800af139d66.png";